<template>
	<div class="class">
		<teacherHeader :logo_name="logo_name" @info-event="myInfoEvent" @public-event="publicEvent"></teacherHeader>
		<div class="task_cont bg_blue">
			<div class="task_cont_div bg_white radius8 bs">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：<router-link to="/task" class="cl_gray">布置作业</router-link>  >  作业篮</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="basket_subject">
					<div class="basket_subject_list bg_blue radius8 cur" v-for="(item,index) in list" :key="index" :class="{'on':list_cur == item.subjectId}"
					 @click="subjectCheck(item.subjectId)">
						<p class="f20px cl_dark">{{item.subjectName}}</p>
						<span class="f16px cl_violet mat5">{{item.check_num}}/{{item.basket_data.length}}</span>
					</div>
				</div>
				<div class="basket_cont">
					<div class="basket_list" v-for="(item,index) in list" :key="index" v-show="item.subjectId == list_cur">
						<div class="basket_list_top flex mat30">
							<label class="flex cur">
								<input type="checkbox" v-model="item.check" class="mar15" @change="((value)=>{checkSubject(index, value)})" />
								<span class="f18px">全选当前学科</span>
							</label>
						</div>
						<div class="basket_list_cont mat10">
							<div class="basket_list_item flex radius8" v-for="(item,secodIndex) in item.basket_data" :key="secodIndex">
								<div class="basket_list_item_l flex">
									<input type="checkbox" v-model="item.check" class="cur" @change="((value)=>{checkOne(index, secodIndex, value)})" />
									<span class="cl_white tc mal15 mar10" :class="{'video':item.type_name=='视频'}">{{item.type_name}}</span>
									<p class="f16px cl_dark">{{item.name}}</p>
								</div>
								<div class="basket_list_item_r hide tc">
									<router-link :to="{ path: '/paper_details', query: { id: item.item_id}}" class="cl_violet mar10" v-if="item.type_name == '试卷'">查看详情</router-link>
									<router-link :to="{ path: '/video', query: { id: item.pack_id , section: item.id}}" class="cl_violet mar10" v-else>查看详情</router-link>
									<span class="cl_dark cur mal10" @click="deleteOne(index,secodIndex)">删除</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="task_basket_empty tc f16px cl_gray" v-if="list.length == 0">
					<p>作业篮为空，请先添加作业。</p>
				</div>
			</div>
		</div>
		<div class="h_100"></div>
		<div class="basket_footer flex bg_white">
			<div class="basket_footer_l flex">
				<label class="flex f18px cur"><input type="checkbox" v-model="check_all" class="mar15" @change="checkAll()" /><span>全选所以学科</span></label>
				<div class="f16px cl_gray flex">
					<p>已选<span class="cl_yel">{{subject_check}}</span>个学科<span class="cl_yel">{{trem_check}}</span>项内容，</p>
					<el-popover placement="top-start" trigger="hover">
						<div class="basket_hide" v-if="basket.length > 0">
							<table class="basket_hide_cont f16px">
								<tr class="basket_hide_item cl_dark">
									<td align="center">学科</td>
									<td align="center">视频</td>
									<td align="center">试卷</td>
								</tr>
								<tr class="basket_hide_item cl_gray" v-for="(item,index) in basket" :key="index">
									<td align="center">{{item.subjectName}}</td>
									<td align="center">{{item.video_num == null || item.video_num == "" || item.video_num == 0 ? "-" : item.video_num}}</td>
									<td align="center">{{item.shijuan_num == null || item.shijuan_num == "" || item.shijuan_num == 0 ? "-" : item.shijuan_num}}</td>
								</tr>
							</table>
						</div>
						<el-button slot="reference" class="cl_yel basket_footer_details f16px">查看详情</el-button>
					</el-popover>
				</div>
			</div>
			<div class="basket_footer_r flex">
				<button class="f18px cl_blue bg_white basket_footer_delete" @click="deleteAll()">移出所选内容</button>
				<button class="f18px cl_white basket_footer_submit" @click="set()">立即布置</button>
			</div>
		</div>
		<!-- 布置作业 -->
		<el-dialog title="布置作业" center :visible.sync="outerVisible" width="40%">
			<el-dialog width="35%" title="添加布置对象" center :visible.sync="innerVisible" append-to-body>
				<div class="class_dialog_nav flex">
					<div class="class_dialog_nav_l flex f18px cl_dark">
						<span class="class_dialog_nav_list cur" :class="{'on': class_cur == 'normal_grade_data'}"
						@click="class_cur = 'normal_grade_data'">行政班</span>
						<span class="class_dialog_nav_list cur" :class="{'on': class_cur == 'tutor_grade_data'}"
						@click="class_cur = 'tutor_grade_data'">教学班</span>
					</div>
					<div class="cl_red">*行政班与教学班不可同时布置</div>
				</div>
				<div class="class_dialog_cont cl_dark f16px">
					<div class="class_dialog_list" v-show="class_cur == 'normal_grade_data'">
						<div v-for="(item,index) in class_data.normal_grade_data" :class="index">
							<div class="mat20 mab20">{{item.gradeName}}</div>
							<div class="class_dialog_list_cont tc">
								<div class="cur radius8 class_dialog_list_item" v-for="(item,secondIndex) in item.class_data" :key="secondIndex"
								:class="{'on':item.check}" @click="normalCheck(index,secondIndex)">{{item.name}}</div>
							</div>
						</div>
					</div>
					<div class="class_dialog_list" v-show="class_cur == 'tutor_grade_data'">
						<div v-for="(item,index) in class_data.tutor_grade_data" :class="index">
							<div class="mat20 mab20">{{item.gradeName}}</div>
							<div class="class_dialog_list_cont tc">
								<div class="cur radius8 class_dialog_list_item" v-for="(item,secondIndex) in item.class_data" :key="secondIndex"
								:class="{'on':item.check}" @click="tutorCheck(index,secondIndex)">{{item.name}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="class_dialog_btm tc mat40">
					<button class="f18px cl_violet radius20 bg_white mar10 class_dialog_cancel" @click="innerVisible = false">取消</button>
					<button class="f18px cl_white radius20 mal10 class_dialog_confirm" @click="classSubmit()">确定</button>
				</div>
			</el-dialog>
			<div class="basket_dialog_cont">
				<div class="basket_dialog_item">
					<div class="basket_dialog_item_l f16px cl_dark"><span>作业标题</span></div>
					<div class="basket_dialog_item_r">
						<input type="text" v-model="basket_name" maxlength="20" placeholder="输入作业标题" class="f16px basket_dialog_item_input" />
					</div>
				</div>
				<div class="basket_dialog_item">
					<div class="basket_dialog_item_l f16px cl_dark"><span>布置对象</span></div>
					<div class="basket_dialog_item_r">
						<div class="basket_dialog_item_class cl_gray f16px" v-if="class_check.length > 0">
							<div v-for="(item,index) in class_check" :key="index" class="radius8">{{item.name}}</div>
						</div>
						<span @click="innerVisible = true" class="cl_violet inline cur basket_dialog_object">{{class_check.length == 0 ? '添加布置对象' : '修改'}}</span>
					</div>
				</div>
				<div class="basket_dialog_item">
					<div class="basket_dialog_item_l f16px cl_dark"><i class="cl_red">*</i><span>作业开始时间</span></div>
					<div class="basket_dialog_item_r flex">
						<div class="flex f16px cl_gray basket_dialog_item_label">
							<label class="flex cur"><input type="radio" :value="1" v-model="set_type" class="mar10" /><span>立即布置</span></label>
							<label class="flex cur"><input type="radio" :value="2" v-model="set_type" class="mar10" /><span>定时布置</span></label>
						</div>
					</div>
				</div>
				<div class="basket_dialog_item" v-show="set_type == 1">
					<div class="basket_dialog_item_l f16px cl_dark"><i class="cl_red">*</i><span>作业截止时间</span></div>
					<div class="basket_dialog_item_r">
						<el-date-picker v-model="end_time" type="datetime" placeholder="选择日期时间"
						 :picker-options="endTimeOption"></el-date-picker>
					</div>
				</div>
				<div class="basket_dialog_item" v-show="set_type == 2">
					<div class="basket_dialog_item_l f16px cl_dark"><i class="cl_red">*</i><span>作业开始与截止时间</span></div>
					<div class="basket_dialog_item_r">
						<el-date-picker v-model="time_range" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
						 :picker-options="rangeTimeOption"></el-date-picker>
					</div>
				</div>
			</div>
			<div class="basket_dialog_btm tc mat50">
				<button type="button" class="basket_dialog_submit f18px cl_white radius20" @click="submit()">确认布置</button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import teacherHeader from '../../components/teacher_header.vue'
	
	export default {
		name: 'basket',
		components: {
			teacherHeader,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				logo_name: "作业篮",
				list: [],
				list_cur: "",
				check_all: false,
				basket: [], //作业篮
				subject_check: 0,
				trem_check: 0,
				ids: "",
				outerVisible: false, //布置作业
				innerVisible: false,
				basket_name: "",
				set_type: 1,
				end_time: "",
				endTimeOption: {
				  disabledDate: date => {
						return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
				  }
				},
				time_range: "",
				rangeTimeOption: {
				  disabledDate: date => {
						return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
				  }
				},
				class_data: {},
				class_cur: "",
				class_check: [],
			}
		},
		created() {
			
		},
		mounted() {
			this.getBasket();
			this.getClass();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//作业篮
			getBasket () {
				this.$get("/api/teacher/get_subject_basket_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					for (let i = 0; i < res.data.length; i++) {
						res.data[i].check_num = 0;
						res.data[i].check = false;
						for (let j = 0; j< res.data[i].basket_data.length; j++) {
							res.data[i].basket_data[j].check = false;
						}
					}
					this.list = res.data;
					this.list_cur = this.list[0].subjectId;
				});
			},
			subjectCheck (e) {
				this.list_cur = e;
			},
			//勾选
			checkOne (index, secodIndex, e) {
				var list = this.list;
				var basket_len = 0;
				var subject_len = 0;
				if (list[index].basket_data[secodIndex].check) {
					for (let i = 0; i < list[index].basket_data.length; i++) {
						if (list[index].basket_data[i].check) {
							basket_len++;
						}
					}
					list[index].check_num = basket_len;
					if (list[index].basket_data.length == basket_len) {
						list[index].check = true;
					}
					for (let j = 0; j < list.length; j++) {
						if (list[j].check) {
							subject_len++
						}
					}
					if (list[index].check_num == 1) {
						this.subject_check++;
					}
					this.trem_check++;
					if (list.length == subject_len) {
						this.check_all = true;
					}
				} else {
					list[index].check = false;
					list[index].check_num--;
					this.check_all = false;
					this.trem_check--;
					if (list[index].check_num == 0) {
						this.subject_check--;
					}
				}
				this.check();
			},
			checkSubject (index, e) {
				var list = this.list;
				var len = 0;
				var trem_check = 0;
				if (list[index].check) {
					if (list[index].check_num == 0) {
						this.subject_check++;
					}
					list[index].check_num = list[index].basket_data.length;
					for (let i = 0; i < list[index].basket_data.length; i++) {
						list[index].basket_data[i].check = true;
					}
					for (let j = 0; j < list.length; j++) {
						if (list[j].check) {
							len++
							for (let k = 0; k < list[j].basket_data.length; k++) {
								if (list[j].basket_data[k].check) {
									trem_check++
								}
							}
						}
					}
					this.trem_check = trem_check;
					if (len == list.length) {
						this.check_all = true;
					}
				} else {
					list[index].check_num = 0;
					this.check_all = false;
					for (let i = 0; i < list[index].basket_data.length; i++) {
						list[index].basket_data[i].check = false;
					}
					this.subject_check--;
					this.trem_check = this.trem_check - this.list[index].basket_data.length;
				}
				this.check();
			},
			checkAll () {
				var trem_check = 0;
				if (this.check_all) {
					for (let i = 0; i < this.list.length; i++) {
						this.list[i].check = true;
						this.list[i].check_num = this.list[i].basket_data.length;
						this.subject_check = this.list.length;
						for (let j = 0; j < this.list[i].basket_data.length; j++) {
							this.list[i].basket_data[j].check = true;
							trem_check++;
						}
					}
					this.trem_check = trem_check;
				} else {
					for (let i = 0; i < this.list.length; i++) {
						this.list[i].check = false;
						this.list[i].check_num = 0;
						for (let j = 0; j < this.list[i].basket_data.length; j++) {
							this.list[i].basket_data[j].check = false;
						}
					}
					this.subject_check = 0;
					this.trem_check = 0;
				}
				this.check();
			},
			check () {
				var arr = [];
				var ids = [];
				for (let i = 0; i < this.list.length; i++) {
					var shijuan_num = 0;
					var video_num = 0;
					var len = 0;
					for (let j = 0; j < this.list[i].basket_data.length; j++) {
						if (this.list[i].basket_data[j].check) {
							if (this.list[i].basket_data[j].type_name == "试卷") {
								shijuan_num++
							} else {
								video_num++
							}
							len ++;
							ids.push(this.list[i].basket_data[j].id);
						}
					}
					if (len > 0) {
						arr.push({subjectName: this.list[i].subjectName, video_num: video_num, shijuan_num: shijuan_num})
					}
				}
				this.ids = ids.join(",");
				this.basket = arr;
			},
			//移除
			deleteOne (index,secodIndex) {
				this.$messageBox.confirm('确定移除所选内容吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$get("/api/teacher/post_del_basket",{
						token: localStorage.getItem("token"),
						ids: this.list[index].basket_data[secodIndex].id,
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: res.msg,
							duration: 1500,
						});
						this.getBasket();
						this.check_all = false;
						this.basket = [];
						this.subject_check = 0;
						this.trem_check = 0;
					});
				}).catch(() => {
					
				});
			},
			deleteAll () {
				if (this.basket.length == 0) {
					this.$message({
						type: 'warning',
						message: '请先选择内容',
						duration: 1500,
					});
					return false
				}
				this.$messageBox.confirm('确定移除所选内容吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.$get("/api/teacher/post_del_basket",{
						token: localStorage.getItem("token"),
						ids: this.ids,
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: res.msg,
							duration: 1500,
						});
						this.getBasket();
						this.check_all = false;
						this.basket = [];
						this.subject_check = 0;
						this.trem_check = 0;
					});
				}).catch(() => {
					
				});
			},
			//布置
			set () {
				if (this.basket.length == 0) {
					this.$message({
						type: 'warning',
						message: '请先选择内容',
						duration: 1500,
					});
					return false
				}
				this.outerVisible = true;
				this.get_start_time = Date.now();
			},
			getClass () {
				this.$get("/api/teacher/get_assign_homework_class",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					for (let i = 0; i < res.data.normal_grade_data.length; i ++) {
						for (let j = 0; j < res.data.normal_grade_data[i].class_data.length; j++) {
							res.data.normal_grade_data[i].class_data[j].check = false;
						}
					}
					for (let k = 0; k < res.data.tutor_grade_data.length; k ++) {
						for (let l = 0; l < res.data.tutor_grade_data[k].class_data.length; l++) {
							res.data.tutor_grade_data[k].class_data[l].check = false;
						}
					}
					this.class_data = res.data;
					this.class_cur = "normal_grade_data";
				});
			},
			normalCheck (index,secondIndex) {
				if (this.class_data.normal_grade_data[index].class_data[secondIndex].check) {
					this.class_data.normal_grade_data[index].class_data[secondIndex].check = false;
				} else {
					this.class_data.normal_grade_data[index].class_data[secondIndex].check = true;
				}
			},
			tutorCheck (index,secondIndex) {
				if (this.class_data.tutor_grade_data[index].class_data[secondIndex].check) {
					this.class_data.tutor_grade_data[index].class_data[secondIndex].check = false;
				} else {
					this.class_data.tutor_grade_data[index].class_data[secondIndex].check = true;
				}
			},
			classSubmit () {
				var arr = [];
				if (this.class_cur == "normal_grade_data") {
					for (let i = 0; i < this.class_data.normal_grade_data.length; i ++) {
						for (let j = 0; j < this.class_data.normal_grade_data[i].class_data.length; j++) {
							if (this.class_data.normal_grade_data[i].class_data[j].check) {
								arr.push(this.class_data.normal_grade_data[i].class_data[j])
							}
						}
					}
				} else {
					for (let i = 0; i < this.class_data.tutor_grade_data.length; i ++) {
						for (let j = 0; j < this.class_data.tutor_grade_data[i].class_data.length; j++) {
							if (this.class_data.tutor_grade_data[i].class_data[j].check) {
								arr.push(this.class_data.tutor_grade_data[i].class_data[j])
							}
						}
					}
				}
				this.class_check = arr;
				this.innerVisible = false;
			},
			getTime (time) {
				let t = "";
				let myDate = new Date(time);
				let year = myDate.getFullYear();
				let month = myDate.getMonth() + 1;
				let date = myDate.getDate();
				let hours = myDate.getHours();
				let minutes = myDate.getMinutes();
				let seconds = myDate.getSeconds();
				if (month < 10) {
					month = "0" + month;
				}
				if (date < 10) {
					date = "0" + date;
				}
				if (hours < 10) {
					hours = "0" + hours;
				}
				if (minutes < 10) {
					minutes = "0" + minutes;
				}
				if (seconds < 10) {
					seconds = "0" + seconds;
				}
				t = year + "-" + month + "-" + date + " " + hours + ":" + minutes + ":" + seconds
				return t;
			},
			submit () {
				var from_time = "";
				var to_time = "";
				var class_ids = [];
				if (this.basket_name == "" || this.class_check.length == 0) {
					this.$message({
						type: 'warning',
						message: '请填写完整内容',
						duration: 1500,
					});
					return false
				}
				if (this.set_type == 1) {
					if (this.end_time == "") {
						this.$message({
							type: 'warning',
							message: '请填写完整内容',
							duration: 1500,
						});
						return false
					}
					from_time = "";
					to_time = this.getTime(this.end_time);
				} else {
					if (this.time_range == "") {
						this.$message({
							type: 'warning',
							message: '请填写完整内容',
							duration: 1500,
						});
						return false
					}
					from_time = this.getTime(this.time_range[0]);
					to_time = this.getTime(this.time_range[1]);
				}
				for (let i = 0; i < this.class_check.length; i++) {
					class_ids.push(this.class_check[i].id);
				}
				class_ids = class_ids.join(",");
				this.$get("/api/teacher/post_basket_assign_homework",{
					token: localStorage.getItem("token"),
					name: this.basket_name,
					class_ids: class_ids,
					from_time: from_time,
					to_time: to_time,
					ids: this.ids,
				})
				.then(res => {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					setTimeout(() => {
						this.$router.push({path: '/basket_success'});
					}, 1500);
				});
			},
		},
	}
</script>

<style>
</style>
